




















import { defineComponent } from '@vue/composition-api'
import type { InsuranceInfoRes } from 'api/api-type'
import Panel from './panel.vue'
export default defineComponent({
  name: 'advantage',
  props: {
    advantage: {
      type: Object,
      default: () => {
        return {} as InsuranceInfoRes['advantage']
      }
    }
  },
  components: {
    Panel
  }
})
